import { Clock, CircleCheckBig } from "lucide-react";
import { pluralize } from "common/utils/format/word";

interface ReviewStatusMessageProps {
  totalImages: number;
  reviewedCount: number;
}

export function ReviewStatusMessage({ totalImages, reviewedCount }: ReviewStatusMessageProps) {
  if (totalImages === 0) return null;

  const unreviewedCount = totalImages - reviewedCount;
  const allReviewed = reviewedCount === totalImages;

  if (allReviewed) {
    return (
      <div className="flex items-center justify-center gap-2 rounded-sm bg-green-100 px-1 py-1">
        <CircleCheckBig className="size-5 text-black" strokeWidth={2} />
        <p className="text-xs font-semibold text-black">
          All images has been reviewed. Proceed to Sizes & Quantities
        </p>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center gap-2 rounded-sm bg-yellow-100 px-1 py-1">
      <Clock className="size-5 text-black" strokeWidth={1.5} />
      <p className="text-xs font-semibold text-black">
        {pluralize(unreviewedCount, "image", "s")} need review before selecting sizes
      </p>
    </div>
  );
}
